
export default {
    name: "popup_enabled_programme",
    props: ["items"],
    data(){
        return {
            selectedLang: "en",
            langText: {
                en: {
                    title: "MyWellness Programme",
                    desc: "Your wellbeing is paramount to us. Should you ever feel in need of assistance, counselling or support, these Workplace Options resources are here for you to tap on, 24 hours a day, 7 days a week.",
                    back: "Back"
                },
                cn: {
                    title: "“健康嘉年华”实施方案",
                    desc: "你的身心健康是我们的头等大事。如需任何帮助、咨询或支持，请随时访问WPO资源，这些资源 24x7 全天候可供使用。",
                    back: "返回"
                }
            },

            playingVideoItem: null,
        }
    },
    computed: {
        filteredItems(){
            return _.filter(this.items, item => {
                return item.type == this.selectedLang || item.type == "both";
            });
        }
    },
    mounted(){

    },
    methods: {
        onClickPlayVideo(item){
            this.playingVideoItem = item;
            this.$emit("update:isSystemMuted", true);
            this.onHandleTriggerAnalytics(`open@${ item.title_ga } (${ this.selectedLang })@enabled_programme`);
        },
        onClickOpenBtn(index, item){
            if(index > 0 && index <= 5){
                this.$store.dispatch("stamp/onSubmitStamp", { title: `MyWellness Programme ${ index }`, room: "Peacetopia" });
                this.onHandleTriggerAnalytics(`open@${ item.title_ga } (${ this.selectedLang })@enabled_programme`);
            }
        },
        onClickBackBtn(){
            this.playingVideoItem = null;
            this.$emit("update:isSystemMuted", false);
        },
        onClickCloseBtn(){
            this.$emit("update:isSystemMuted", false);
            this.$emit("update:currentPopupItem", null);
            this.onHandleTriggerAnalytics(`close@enabled_programme`);
        },
    },
    watch: {
        "selectedLang"(){
            this.onHandleTriggerAnalytics(`change_language@${ this.selectedLang }@enabled_programme`); 
        }
    }
}
